import {Component, EventEmitter, Input, OnInit, OnDestroy, Output} from '@angular/core';
import {ApprovalTripService} from '../../approval-trip.service';
import {resetServiceEnabled, verifyServiceEnabled} from '../../../../A2-utils/export-functions/functions-services';
import {Subscription} from 'rxjs/Subscription';

@Component({
  selector: 'app-appeal-trip',
  templateUrl: './appeal-trip.component.html',
  styleUrls: ['./appeal-trip.component.scss']
})
export class AppealTripComponent implements OnInit, OnDestroy {

  @Input() tripId: any;
  @Output() eventAppeal?: EventEmitter <any> = new EventEmitter <any>();
  protected comment: any;
  private observables: Subscription[] = [];

  constructor(
    private _approvalService: ApprovalTripService
  ) { }

  ngOnInit() {
  }

  saveAction() {
    if (verifyServiceEnabled('servicePostAppealClaim')) {
      const data = {
        'tripId': this.tripId,
        'Observations': this.comment
      };
      this.observables.push(this._approvalService.postAppealClaim(data).subscribe(
        resp => {
          this.eventAppeal.emit(true);
          resetServiceEnabled('servicePostAppealClaim');
        },
        error => {
          resetServiceEnabled('servicePostAppealClaim');
        }
      ));
    }
  }

  ngOnDestroy(): void {
    this.observables.forEach(
      (sub: Subscription) => {sub.unsubscribe(); }
    );
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/trip-reservations/approval-trip/component/appeal-trip/appeal-trip.component.ts